import React, { useEffect, useState } from "react";
import { getCustomerCheckoutStatus, getCustomerUserInfo, getUserCheckoutStatus } from "../../../Actions";
import SampleCheckoutDialog from "../SampleCheckoutDialog";
import SignInAlert from "../SignInAlert";
import { Button } from "@material-ui/core";
import '../../styles/Product.css';
import CustomerSampleCheckoutDialog from "../CustomerSampleCheckoutDialog";
import { LibraryAddCheck } from "@material-ui/icons";

export default function SampleCheckouts(props) {
  
  const [isSignInAlertOpen, setIsSignInAlertOpen] = useState(false);
  const [checkoutId, setCheckoutId] = useState();
  const [checkoutList, setCheckoutList] = useState([]);
  const [isCheckoutDialogOpen, setIsCheckoutDialogOpen] = useState(false);
  const [isCustomerCheckoutDialogOpen, setIsCustomerCheckoutDialogOpen] = useState(false);
  const [userData, setUserData] = useState([]);

  const checkoutStatus = async () => {
    if (['a','ro','rw'].includes(props.user.access_type_cd)) {
      await getUserCheckoutStatus(props.product?.product_uuid)
        .then((result) => {
          setCheckoutList(result.data.additional_user_checkout_status);
          if (result.data.checkout_status !== '') {
            setCheckoutId(result.data.sample_checkout_id);
          }
        })
        .catch((err) => {
          
        });
    } else if (props.user.access_type_cd === 'c') {
      await getCustomerCheckoutStatus(props.product?.product_uuid)
        .then((result) => {
          setCheckoutList(result.data);
          setCheckoutId(result.data.sample_checkout_id);
        })
        .catch((err) => {
          
        })
    } 

    return;
  };

  const onClickCheckout = () => {
    if (!props.user?.user_id) {
      setIsSignInAlertOpen(true);
      return;
    }

    if (['a','ro','rw'].includes(props.user?.access_type_cd)) {
      setIsCheckoutDialogOpen(true);
      return;
    } 
    
    setIsCustomerCheckoutDialogOpen(true);
  };

  const getCustomerInfo = async () => {
    await getCustomerUserInfo()
      .then((result) => {
        setUserData(result.data.data);
      })
      .catch((err) => {
        
      });
  }

  useEffect(() => {
    if (!props.user?.access_type_cd || !props.user?.user_id) {
      setCheckoutList([]);

      return;
    }

    // userData populates the guest-checkout autocompletes in SampleCheckoutDialog,
    // which only renders for admin/ro/rw. Customers get CustomerSampleCheckoutDialog,
    // which doesn't take a users prop — so skip the /api/user/customer/data call for them.
    if (['a','ro','rw'].includes(props.user.access_type_cd)) {
      getCustomerInfo();
    }
    checkoutStatus();
  }, [])

  const deduppedOptions = [];
  
  props.product?.options?.filter(o => !o.discontinued).forEach(option => {
    if (!deduppedOptions.find(i => i.product_sku_uuid === option.product_sku_uuid)) {
      deduppedOptions.push(option);
    }

    return;
  });

  // Label for the checkout cart, so samples from this page read the same way as ones
  // added by scanning another code.
  const productLabel = [
    props.product?.manufacturer_name,
    props.product?.private_style || props.product?.style,
    props.product?.private_trade_name || props.product?.trade_name,
  ]
    .filter((part) => part)
    .join(' ');

  if (props.areCheckoutsAllowed === 0) return <></>;

  return (
    <>
      <Button
        variant="contained" fullWidth style={{backgroundColor: "#FFFFFF"}}
        onClick={onClickCheckout}
      >
        <LibraryAddCheck style={{marginRight: "6px"}}/> Checkout
      </Button>
      {props.user && props.user.access_type_cd !== 'c' ? (
        <SampleCheckoutDialog
          isOpen={isCheckoutDialogOpen}
          productId={props.product?.product_uuid}
          productName={productLabel}
          locationId={props.locationId}
          checkoutList={checkoutList}
          users={userData}
          user={props.user}
          options={deduppedOptions}
          checkoutId={checkoutId}
          checkoutIconLabel={'Checkout Sample'}
          checkoutIconColor={'#616161'}
          checkoutStatus={() => checkoutStatus()}
          checkoutStatusInd={'ci'}
          onClose={() => setIsCheckoutDialogOpen(false)}
        />
      ) : undefined}
      {props.user && props.user?.access_type_cd === 'c' ? (
        <CustomerSampleCheckoutDialog 
          isOpen={isCustomerCheckoutDialogOpen}
          checkoutList={checkoutList}
          user={props.user}
          product={props.product}
          options={deduppedOptions}
          checkoutStatus={() => checkoutStatus()}
          onClose={() => setIsCustomerCheckoutDialogOpen(false)}
        />
      ) : undefined}

        <SignInAlert 
          isOpen={isSignInAlertOpen}
          onClose={() => setIsSignInAlertOpen(false)}
        />
    </>
  )
}